import { inject, Injectable } from '@angular/core';
import { EncryptionService } from './encryption.service';
import { GtmService } from './google-tag-manager.service';
import { CombinedStore } from 'src/app/core/combined.store';
import { environment } from 'src/environments/environment';

export type GtmTrackedEvent =
  | 'price_view'
  | 'form_devis_submit'
  | 'contract_signature_submit'
  | 'funnel_step';

export type GtmEventArguments =
  | [eventName: Exclude<GtmTrackedEvent, 'funnel_step'>]
  | [eventName: 'funnel_step', data: { step_name: string }];

@Injectable({
  providedIn: 'root'
})
export class GtmEventServiceService {
  private store = inject(CombinedStore);
  constructor(
    private gtmService: GtmService,
    private encryptionService: EncryptionService,
  ) { }

  async pushEvent(...[eventName, data]: GtmEventArguments): Promise<void> {
    const productName = this.store.path() === "" ? environment.product : this.store.path();
    const offer = productName + '_' + environment.brand;
    const partnerCode = this.store.context().partnerCode ?? 'VYV';

    let eventData: any;

    switch (eventName) {
      case 'price_view':
      case 'form_devis_submit':
      case 'contract_signature_submit':
        const { hashedEmail, phonePrefix } = await this.buildUserData();
        eventData = {
          user_data_em: hashedEmail,
          user_data_ph: phonePrefix,
          form_name: offer,
          partner_code: partnerCode,
        };
        break;

      case 'funnel_step':
        eventData = {
          form_name: offer,
          partner_code: partnerCode,
          step_name: data.step_name,
        };
        break;
    }

    this.gtmService.pushEvent(eventName, eventData);
  }

  private async buildUserData(): Promise<any> {
    const email = this.store.subscriber().email ?? '';
    const hashedEmail = email ? await this.encryptionService.sha256Hex(email) : '';
    const phonePrefix = this.store.subscriber().phone_prefix.phone !== undefined && this.store.subscriber().phone_prefix.phone !== ''
      ? (this.store.subscriber().phone_prefix.indicator?.prefix ?? '') + this.store.subscriber().phone_prefix.phone : '';
    return { hashedEmail, phonePrefix };
  }
}
